export default __webpack_public_path__ + "static/media/hp ios.0a592b5d.png";